<template>
  <div class="cargo-details-truck">
    <div class="title custom-title">Cargo Details</div>
    <validation-observer name="Cargo-truck" ref="validateCargoTruck">
      <b-card class="b-card-bg">
        <b-row class="mb-2">
          <b-col lg="3">
            <label>Booking No.</label>
            <b-form-input
              :disabled="readonly"
              class="iuput"
              v-model="value.cargo_booking"
              placeholder="Enter Booking No."
              required
            ></b-form-input>
          </b-col>
          <b-col lg="1"></b-col>
          <b-col lg="3">
            <label>Carrier</label>
            <Select4
              v-model="value.shipping_line"
              placeholder="Carrier"
              :disabled="readonly"
              :options="{
                isSearch: true,
                value: 'id',
                label: 'text',
                data: shipping_lines,
                fields: [
                  {
                    field: 'code',
                    label: 'Code',
                  },
                  {
                    field: 'name',
                    label: 'Shipping Line',
                  },
                ],
              }"
            />
          </b-col>
          <b-col lg="1"></b-col>
          <b-col lg="3">
            <label>Cargo closing time</label>
            <b-row>
              <b-col class="pr-0">
                <date-picker
                  :disabled="readonly"
                  ref="datePicker"
                  v-model="value.cargo_closing_date"
                  type="date"
                  title-format="DD/MM/YY"
                  time-title-format="DD/MM/YY"
                  placeholder="Select date"
                  format="DD/MM/YY"
                  class="w-full"
                  value-type="format"
                >
                </date-picker>
              </b-col>
              <b-col>
                <date-picker
                  :disabled="readonly || value.isPOD_VN"
                  v-model="value.cargo_closing_time"
                  ref="datePicker"
                  type="time"
                  title-format="HH:mm"
                  time-title-format="HH:mm"
                  placeholder="Select time"
                  format="HH:mm"
                  class="w-full"
                  value-type="format"
                >
                </date-picker>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row
          v-for="itemCommodity in value.valueContainer"
          :key="itemCommodity.id"
          class="mt-1"
        >
          <b-col lg="3">
            <validation-provider
              name="Commodity Type"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label class="flex"
                  >Commodity Type
                  <div class="red">*</div></label
                >
                <Select2
                  :disabled="readonly"
                  placeholder="Select Commodity type"
                  v-model="itemCommodity.commodity_type"
                  :options="goods_types"
                />
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col lg="1"></b-col>
          <b-col lg="3">
            <validation-provider
              name="Commodity"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label class="flex"
                  >Commodity
                  <div class="red">*</div>
                </label>
                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  :disabled="readonly"
                  class="iuput"
                  v-model="itemCommodity.commodity"
                  type="text"
                  placeholder="Commodity"
                  required
                ></b-form-input>
                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col class="mt-20" v-if="!readonly">
            <div
              v-if="!itemCommodity.hasDelete"
              class="custom-add-line"
            >
              <b-img width="30px"
              @click="handleAddLineCommodity"
               :src="iconAdd" alt="logo" />
            </div>

            <div
              v-if="itemCommodity.hasDelete"
              class="custom-delete"
            >
              <b-img width="30px"
              @click="handleDeleteCargoCommodity(itemCommodity.id)"
               :src="remove" alt="logo" />
            </div>
          </b-col>
          <b-col lg="12">
            <b-row
           
              class="mt-1"
            >
              <b-col lg="3">
                <validation-provider
                  name="Container Type"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label class="flex"
                      >Container Type
                      <div class="red">*</div></label
                    >
                    <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonly"
                      placeholder="Container Type"
                      v-model="itemCommodity.cont_type"
                      :options="
                        cont_types.filter((i) => i.group === 'Container truck')
                      "
                    />
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col lg="1"></b-col>
              <b-col lg="3">
                <validation-provider
                  name="Quantity"
                  #default="{ errors }"
                  rules="required|minNumber:0"
                >
                  <b-form-group>
                    <label class="flex"
                      >Quantity 
                      <div class="red">*</div>
                    </label>
                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      class="iuput"
                      v-model="itemCommodity.quantity"
                      type="number"
                      @input="checkNumber(itemContainer)"
                      placeholder="Quantity"
                      required
                    ></b-form-input>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col lg="1"></b-col>
              <b-col lg="3">
                <validation-provider
                  name="Total gross weight (Kgs)"
                  #default="{ errors }"
                  rules="required|minNumber:0"
                >
                  <b-form-group>
                    <label class="flex"
                      >Total gross weight (Kgs)
                      <div class="red">*</div>
                    </label>
                    <cleave
                    :state="errors.length > 0 ? false : null"
                          :disabled="readonly"
                          :options="$Utils.CONSTANTS.cleaveNumeral"
                          v-model="itemCommodity.total_gross_weight"
                          class="form-control"
                          placeholder="Total gross weight (Kgs)"
                      required
                        />
                    <!-- <b-form-input
                      :state="errors.length > 0 ? false : null"
                      :disabled="readonly"
                      class="iuput"
                      v-model="itemContainer.total_gross_weight"
                      type="text"
                      placeholder="Total gross weight (Kgs)"
                      required
                    ></b-form-input> -->
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
             
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </validation-observer>
  </div>
</template>

<script>
import Select2 from "v-select2-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import {
  BButton,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
} from "bootstrap-vue";
export default {
  components: {
    BButton,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    Select2,
  },
  data() {
    return {
      iconAdd: require("@/assets/images/icons/add.png"),
      remove: require("@/assets/images/icons/remove.png"),
      check_country_pick_up: null,
      check_country_delivery: null,
    };
  },
  props: {
    value: {
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  computed: {
    ...mapState("masterData", [
      "service_types",
      "ports",
      "incoterms",
      "cont_types",
      "goods_types",
      "transport_types",
      "deports_locations",
      "deports",
      "business_types",
      "customs_types",
      "shipping_lines",
      "regions",
      "companyItems",
      "fee_types",
      "handed_types",
      "quotations",
      "locations",
    ]),
  },
  watch: {},
  methods: {
    checkNumber(itemContainer) {
      if (itemContainer.quantity < 0) {
        itemContainer.quantity = 0;
      } else if (itemContainer.quantity > 99) {
        itemContainer.quantity = 99;
      }
    },
    handleAddLineCommodity() {
      const randomID =
        Math.random().toString(36).substr(2, 9) + "-" + Date.now();
      const randomID2 =
        Math.random().toString(30).substr(1, 8) + "-" + Date.now();
      const newElement = {
        id: randomID,
        hasDelete: true,
        commodity_type: null,
        commodity: null,
        container_type: null,
            quantity: null,
            total_gross_weight: null,
        
      };
      this.value.valueContainer.push(newElement);
    },
    handleDeleteCargoCommodity(id) {
      this.value.valueContainer = this.value.valueContainer.filter(
        (item) => item.id !== id
      );
    },

  },
};
</script>

<style lang="scss">
.cargo-details-truck {
  .custom-title {
    align-items: center;
    display: flex;
    height: 43px;
  }
  .container-checkbox {
    display: flex;
    margin-top: 29px;
    align-items: center;
    gap: 5px;
  }
  label {
    color: #000000;
    font-weight: 600;
  }
  .form-control {
    border: 0 !important;
  }
  .b-card-bg {
    height: auto;
    padding: 1.5rem;
    @media (max-width: 992px) {
      height: 350px;
    }
  }
  .mx-input {
    border: none !important;
  }
  .mt-20 {
    margin-top: 30px;
  }
  .custom-delete {
    margin-top: 5px;
    cursor: pointer;
  }
  .custom-add-line {
    cursor: pointer;
  }
  .select2-selection--single {
    border: none !important;
  }
  .select2-selection--single:before {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAmElEQVQokZ3SwQ3CIBTG8X+7gI6BNzawq3jnoOyBMcEBOooj1BNXV3ACzDOSGEuL8CWEvPeR34lOebcFRkDulD31uQNDF2Nkdz1r4AZsGiDJE9DB2EcvUzB2Ev1TtGCDYDL0aduIJmxKi/67rURn2AysRI+/WBb8Ez0EY8dckQUL6CK2Ci6gpzXsHfmHpaO808q7S/FtjLwAmwh101zduSgAAAAASUVORK5CYII=") !important;
  }
}
</style>
